import { render, staticRenderFns } from "./PayPalPaymentResult.vue?vue&type=template&id=aae7bd00&scoped=true&"
import script from "./PayPalPaymentResult.vue?vue&type=script&lang=ts&"
export * from "./PayPalPaymentResult.vue?vue&type=script&lang=ts&"
import style0 from "./PayPalPaymentResult.vue?vue&type=style&index=0&id=aae7bd00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae7bd00",
  null
  
)

export default component.exports